module.exports = __webpack_public_path__ + "img/01.2568fbfb.jpg";